export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 4_01.24c7b1fc.jpg";